import { Component, OnInit } from '@angular/core';
import {
  AbstractControl,
  FormBuilder,
  FormGroup,
  Validators,
} from '@angular/forms';
import { Router } from '@angular/router';
import { LoginServiceService } from 'src/app/_services/login-service.service';
const emailPhonePattern =
'^([a-zA-Z0-9_.-])+@(([a-zA-Z0-9-])+.)+([a-zA-Z0-9]{2,4})|(^[0-9]{10})+$';

@Component({
  selector: 'app-login',
  templateUrl: './login.component.html',
  styleUrls: ['./login.component.css'],
})
export class LoginComponent implements OnInit {
  hide = true;
  loginForm: FormGroup;
  submitted: boolean = false;
  error: any;
  token: any;
  errorMsg: boolean = false;
  constructor(
    private formBuilder: FormBuilder,
    private router: Router,
    private loginService: LoginServiceService
  ) {
    this.loginForm = this.formBuilder.group({
      email: ['', [Validators.required, Validators.pattern(emailPhonePattern)]],
      password: ['', [Validators.required]],
    });
  }

  ngOnInit(): void {
    if (localStorage.getItem('token') != null) {
      this.router.navigate(['/Dashboard']);
    }
  }
  login() {
    if (this.loginForm.invalid) {
      this.submitted = true;
    } else {
      console.log(this.loginForm.value);
      let obj = {
        email: this.loginForm.value.email,
        password: this.loginForm.value.password,
      };
      // localStorage.setItem('token', this.token);
      // this.router.navigate(['/Dashboard']);
      this.loginService.login(obj).subscribe(
        (result) => {
          console.log(result);
          this.token = result.token;
          this.loginForm.reset();
          localStorage.setItem('token', this.token);
          this.router.navigate(['/Dashboard']);
        },
        (err) => {
          console.log(err.error.message);
          this.error = err.error.message;
          setTimeout(() => {
            this.error = '';
          }, 3000);
        }
      );
    }
  }
  get f(): { [key: string]: AbstractControl } {
    return this.loginForm.controls;
  }
}
